import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-install-nativ-n4',
  templateUrl: './install-nativ-n4.component.html',
  styleUrls: ['./install-nativ-n4.component.scss']
})
export class InstallNativN4Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
